import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";
import AuthLayout from "../layouts/AuthLayout";
import BackSVG from "../../assets/images/svgs/arrow-left.svg";
import { GetStartedTabs } from "../../utils/mapper/Mapper";

const Register = () => {
  const navigate = useNavigate();

  const goBack = () => {
     navigate(-1);
  }

  const getLink = (key: string) => {
    switch (key) {
      case "TRUQ":
        return "https://mytruq.siju.it/auth/login";
      case "SIJU":
        return "https://app.siju.it/auth/login";
      case "PARTNER":
        return "https://mytruq.siju.it/auth/login";
      case "MOVE":
        return "https://app.mytruq.com/auth/login";
      default:
        return "https://app.mytruq.com/auth/login";
    }
  };

  const getDescription = (key: string) => {
    switch (key) {
      case "TRUQ":
        return "Sign up on truQ to get access to all you need to grow your logistics hustle.";
      case "SIJU":
        return "Sign up on Siju to unlock continuously efficient 3PL operations. Access vehicles on truQ and streamline your logistics operations.";
      case "PARTNER":
        return "Sign up as a Partner to make extra revenue by offering an all-in-one seamless logistics and home maintenance service to your customers.";
      case "MOVE":
        return "Sign up on Move to access seamless logistics and home maintenance service, before during and after your move.";
      default:
        return "";
    }
  };

  return (
    <AuthLayout step={1}>
      <Fragment>
        <div className="d-flex flex-row my-2 cursor-pointer" onClick={goBack}>
          <Image src={BackSVG} alt="GO_BACK" />
          <p className="text-black">Go Back</p>
        </div>

        <div className="d-flex flex-column justify-content-between">
          <h4 className="text-start mt-1 mt-lg-5 text-black">
            Get Started
          </h4>
          <p className="text-office-brown-700 mb-3 text-start">
            Choose a product to continue to its sign-in page.
          </p>
        </div>

        <div className="row mt-3">
          {GetStartedTabs.map((item) => (
            <div className="col-12 col-md-6 mb-3" key={item.value}>
              <a
                className="cursor-pointer card border-primary text-decoration-none h-100 get-started-card"
                href={getLink(item.value)}
                target="_blank"
                rel="noreferrer"
              >
                <div className="d-flex flex-column justify-content-between h-100 p-3">
                  <div>
                    <h5 className="mb-2 text-black">{item.text}</h5>
                    <p className="mb-3 text-office-brown-700">
                      {getDescription(item.value)}
                    </p>
                  </div>
                  {/* <span className="text-primary-emphasis fw-semibold">Sign in</span> */}
                </div>
              </a>
            </div>
          ))}
        </div>
      </Fragment>
    </AuthLayout>
  );
};

export default Register;
